import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

// Loading placeholder block; size it via className (h-*/w-*).
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-control bg-grey-100", className)} {...props} />;
}
